import RiskLegend from './RiskLegend';

export default RiskLegend;
